import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { globalStyles as styles } from './style/gstheme';
import { sanitiseText } from './utils/utils';

class PagingFilter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: this.props.text ? this.props.text : "",
      clear: this.props.text && this.props.text !== ""
    };
    this.textInput = React.createRef();
  }

  filterLabel = (event) => {
    const cleanText = sanitiseText(event.target.value);
    this.setState({ text: cleanText });
  };

  clearFilter = () => {
    this.setState({
      text: "",
      clear: false
    });
    this.props.handleFilterChange("");
    this.textInput && this.textInput.current && this.textInput.current.focus();
  };

  applyFilter = () => {
    this.setState({ clear: true });
    this.props.handleFilterChange(this.state.text.trim());
  };

  render() {

    const { text, clear } = this.state;
    const { classes, autoFocus, placeholder, includeLabel, maxLength, altered, label, minLength, disabled } = this.props;

    return (
      <div style={{ height: '50px' }}>
        <form autoComplete="off">
          {includeLabel && <InputLabel className={classes.formSelectorLabel} style={{ fontSize: '12px', marginBottom: '5px' }}>{label}</InputLabel>}
          <TextField
            disabled={disabled}
            data-test="filter"
            fullWidth margin="dense"
            id="text"
            name="text"
            value={text}
            inputRef={this.textInput}
            style={{ marginTop: '0px' }}
            autoFocus={autoFocus}
            variant="outlined"
            onKeyPress={(ev) => {
              if (ev.charCode === 13) {
                if (text.length >= minLength) {
                  this.applyFilter();
                }
                ev.preventDefault();
                ev.stopPropagation();
              }
            }}
            placeholder={placeholder || (minLength === 0 ? "Enter text to filter" : "Enter " + minLength + " characters or more")}
            onChange={this.filterLabel}
            InputLabelProps={{
              className: classes.inputLabel
            }}
            InputProps={{
              className: classes.inputLabel,
              inputProps: {
                "data-test": "filter-input",
                maxLength: maxLength
              },
              endAdornment:
                !disabled ?
                  <InputAdornment position="end">
                    <Tooltip title={clear && text !== "" ? "Clear filter" : "Apply filter"}>
                      <span>
                        {altered ?
                          <RefreshIcon data-test="refresh" className={classes.inputIconHighlighted} onClick={this.applyFilter} />
                          :
                          (clear && text !== "" ?
                            <ClearIcon data-test="clear" className={classes.inputIconHighlighted} onClick={this.clearFilter} />
                            :
                            text.length >= minLength ?
                              <SearchIcon data-test="search" className={classes.inputIconHighlighted} onClick={this.applyFilter} />
                              :
                              null
                          )
                        }
                      </span>
                    </Tooltip>
                  </InputAdornment>
                  :
                  null
            }}
          />
        </form>
      </div>
    );
  }

}

PagingFilter.defaultProps = {
  autoFocus: true,
  includeLabel: false,
  disabled: false,
  altered: false,
  label: "Filter",
  minLength: 0,
  maxLength: 30
};

PagingFilter.propTypes = {
  handleFilterChange: PropTypes.func.isRequired,
  altered: PropTypes.bool,
  autoFocus: PropTypes.bool,
  text: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  includeLabel: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  classes: PropTypes.object
};

export default withStyles(styles)(PagingFilter);